<template>
  <Modal :open="open" size="medium" :showCloseButton="false">
    <div class="sm:flex sm:items-start">
      <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">
          🚨 Veuillez compléter vos informations pour accéder à votre espace
        </h3>

        <div class="mt-2">
          <p class="text-sm text-gray-500 mb-6">
            Afin de poursuivre votre navigation et accéder à vos contrats, merci de renseigner les informations
            manquantes ci-dessous.
          </p>

          <div class="space-y-4">
            <FormField
              id="phone"
              name="phone"
              label="Numéro de téléphone"
              type="tel"
              v-model="formData.phone"
              required
            />

            <BirthDateInput
              id="birthDate"
              name="birthDate"
              v-model="formData.birthDate"
              required
              :minAge="18"
              :maxAge="120"
            />

            <FormField
              id="birthCity"
              name="birthCity"
              label="Ville de naissance"
              v-model="formData.birthCity"
              required
            />

            <FormField
              id="birthCountry"
              name="birthCountry"
              label="Pays de naissance"
              v-model="formData.birthCountry"
              required
            />
          </div>

          <div class="mt-6 bg-gray-50 p-4 rounded-md">
            <h4 class="text-sm font-medium text-gray-900 mb-2">🛡️ Pourquoi ces informations sont nécessaires ?</h4>
            <p class="text-sm text-gray-500 mb-4">
              Conformément à l'article L561-5 du Code monétaire et financier et à l'article L113-2 du Code des
              assurances, Estaly a l'obligation légale de vérifier l'identité de ses assurés.
            </p>
            <p class="text-sm text-gray-500">
              Sans ces éléments, votre contrat ne pourra pas être validé ni géré correctement.
            </p>
          </div>

          <div class="mt-4 bg-gray-50 p-4 rounded-md">
            <h4 class="text-sm font-medium text-gray-900 mb-2">🔒 Vos données sont en sécurité</h4>
            <p class="text-sm text-gray-500">
              Ces informations sont strictement confidentielles et ne seront utilisées que pour satisfaire nos
              obligations réglementaires.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <button
        type="button"
        class="w-full inline-flex justify-center rounded-md border border-transparent shadow-xs px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm"
        @click="handleSubmit"
      >
        Continuer
      </button>
    </div>
  </Modal>
</template>

<script>
import { Modal, FormField, BirthDateInput } from "@estaly/ui";
import CustomerService from "@/api/services/customer";
import { mapState, mapActions } from "vuex";

export default {
  name: "RequiredInfoModal",
  components: {
    Modal,
    FormField,
    BirthDateInput,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState("auth", ["currentUser"]),
  },
  data() {
    return {
      formData: {
        phone: "",
        birthDate: "",
        birthCity: "",
        birthCountry: "",
      },
    };
  },
  created() {
    this.updateFormData();
  },
  watch: {
    currentUser: {
      handler() {
        this.updateFormData();
      },
      deep: true,
    },
    open(newValue) {
      if (newValue) {
        this.updateFormData();
      }
    },
  },
  methods: {
    ...mapActions("auth", ["refreshCurrentUser"]),

    updateFormData() {
      this.formData = {
        phone: this.currentUser.phone || "",
        birthDate: this.currentUser.birthDate || "",
        birthCity: this.currentUser.birthCity || "",
        birthCountry: this.currentUser.birthCountry || "",
      };
    },

    async handleSubmit() {
      const customerData = {
        customer: {
          phone: this.formData.phone,
          birthDate: this.formData.birthDate,
          birthCity: this.formData.birthCity,
          birthCountry: this.formData.birthCountry,
        },
      };
      const response = await CustomerService.updateCustomer(this.currentUser.id, customerData);
      if (!response?.success) return;

      this.refreshCurrentUser();
      this.$emit("submit");
    },
  },
};
</script>
